import { gql } from "apollo-boost";

export const GET_CATEGORYS = gql`
query Data($where: CategoryWhereInput, $orderBy: OrderByInput, $limit: Int) {
    categories(where: $where, orderBy: $orderBy, limit: $limit) {
      data {
        id
        name
        image
        coverImages
        detail
        level
        status
        isDeleted
        createdAt
        updatedAt
        note
        sort
        shop {
          id 
        } 
      }
      total
    }
  }
`;
 